import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router';

import supportSelectors from '@/redux/support/supportSelectors';
import appSelectors from '@/redux/app/appSelectors';

import { setDisplayMenu } from '@/redux/app/appSlice';

import supportOperations from '@/redux/support/supportOperations';

import RouteNames from '@/router/routes';

import SupportIcon from '@/images/nav_icons/support.svg?react';

import s from './btnSupport.module.css';

const supportLink = `/${RouteNames.SUPPORT}`;

const navlinkStyles = ({ isActive }) =>
  isActive ? s.navlink_active : s.navlink;

function BtnSupport() {
  const dispatch = useDispatch();

  const i18n = useSelector(appSelectors.translation);
  const counter = useSelector(supportSelectors.countUnreadMessages);

  const hideMenu = () => dispatch(setDisplayMenu(false));

  useEffect(() => {
    dispatch(supportOperations.getUnreadTickets());

    const repeatedAction = setInterval(() => {
      dispatch(supportOperations.getUnreadTickets());
    }, 10000);

    return () => clearInterval(repeatedAction);
  }, [dispatch]);

  return (
    <NavLink to={supportLink} onClick={hideMenu} className={navlinkStyles}>
      <SupportIcon stroke="currentColor" className={s.icon} />
      <span>{i18n.Support}</span>
      {counter > 0 && <p className={s.counter}>{counter}</p>}
    </NavLink>
  );
}

export default BtnSupport;
